import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7aabdd0c")

_pushScopeId("data-v-7aabdd0c")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "right-container flex-grow flex flex-col justify-between h-screen" }
const _hoisted_3 = { class: "flex-grow flex flex-col items-start bg-primary-100 overflow-y-scroll overflow-x-scroll px-12 pt-12" }
const _hoisted_4 = { class: " hidden lg:flex flex-col mb-4 px-4 py-3 rounded-md" }
const _hoisted_5 = { class: "flex flex-col justify-between gap-3" }
const _hoisted_6 = { class: "text-3xl font-bold" }
const _hoisted_7 = { class: "text-gray-500" }
const _hoisted_8 = {
  key: 0,
  class: "w-full panel-container rounded-md bg-white pb-2 mb-16 lg:mb-8"
}
const _hoisted_9 = { class: "relative z-10 flex items-center justify-between w-full table-header-color px-4 py-3" }
const _hoisted_10 = { class: "flex items-center sticky left-0" }
const _hoisted_11 = { class: "mr-2" }
const _hoisted_12 = {
  key: 1,
  class: "w-full rounded-md bg-white p-2"
}
const _hoisted_13 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-8"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "text-gray-500 text-sm" }, "情報取得中...", -1)
const _hoisted_15 = {
  key: 1,
  class: "text-center"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MNavBar = _resolveComponent("MNavBar")
  const _component_MHeaderPanel = _resolveComponent("MHeaderPanel")
  const _component_m_table = _resolveComponent("m-table")
  const _component_MLoadingIcon = _resolveComponent("MLoadingIcon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_MNavBar),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_MHeaderPanel, {
        title: "QANDA質問一覧",
        breadcrumbs: _ctx.breadcrumbs
      }, null, 8, ["breadcrumbs"]),
      _createVNode("main", _hoisted_3, [
        _createVNode("section", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("p", _hoisted_6, _toDisplayString(`生徒名: ${_ctx.student ? _ctx.student.data.name : "取得中..."}`), 1),
            _createVNode("p", _hoisted_7, _toDisplayString(`Qanda ID: ${_ctx.student ? _ctx.student.data.qandaUserId : "取得中..."}`), 1)
          ])
        ]),
        (_ctx.datas && _ctx.datas.length > 0)
          ? (_openBlock(), _createBlock("section", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _createVNode("div", _hoisted_11, [
                    _withDirectives(_createVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchKeyword = $event)),
                      type: "search",
                      name: "searchStudent",
                      placeholder: "IDで検索...",
                      class: "w-32 sm:w-60 bg-white rounded border border-white focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-300"
                    }, null, 512), [
                      [_vModelText, _ctx.searchKeyword]
                    ])
                  ])
                ])
              ]),
              _createVNode(_component_m_table, {
                datas: _ctx.filteredDatas,
                definitions: _ctx.definitions,
                "count-per-page": 40,
                onChange: _ctx.changeSelectedId
              }, null, 8, ["datas", "definitions", "onChange"])
            ]))
          : (_openBlock(), _createBlock("section", _hoisted_12, [
              (_ctx.loading)
                ? (_openBlock(), _createBlock("div", _hoisted_13, [
                    _createVNode(_component_MLoadingIcon),
                    _hoisted_14
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_15, "チャット履歴がありません。"))
            ]))
      ])
    ])
  ]))
})